import React, { useState } from 'react';
import { useForm } from "react-hook-form";
import { useCurrentUser } from "../context/contextHooks";
import { useSxStyles    } from "../styles/sxStyles";
import {getCaseLabel, getCitationLabel, validateSearch, getSearchRequest, getLicenseLabel} from "./lookupFunctions";
import Box from "@mui/material/Box";
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Grid2 from '@mui/material/Grid2';
import TabContext from "@mui/lab/TabContext";
import TabPanel from '@mui/lab/TabPanel';
import FormControl from '@mui/material/FormControl';
import FormLabel from "@mui/material/FormLabel";
import TextField from '@mui/material/TextField';
import Button from "@mui/material/Button";
import Alert from '@mui/material/Alert';
import Typography from "@mui/material/Typography";
import Dob from './Dob';
import ManageSearchIcon from '@mui/icons-material/ManageSearch';
import RotateLeftIcon from '@mui/icons-material/RotateLeft';
import AlertTitle from "@mui/material/AlertTitle";
import UserReceipts from "./UserReceipts";
import AddIcCallTwoToneIcon from '@mui/icons-material/AddIcCallTwoTone';
import Tooltip from "@mui/material/Tooltip";
import {InfoOutlined} from "@mui/icons-material";
import Zoom from "@mui/material/Zoom";
import InputAdornment from "@mui/material/InputAdornment";
import Popup from "../layout/Popup";

const Search = (props) => {
    const court = props.court;
    const retrieveBalances = props.retrieveBalances;
    const logEntry = props.logEntry;
    const setNewCall = props.setNewCall;
    const [user,] = useCurrentUser();
    const classes = useSxStyles;
    const [tabVal, setTabVal] = useState('2');
    const { register, setValue, handleSubmit } = useForm();
    const [dob, setDob] = useState(null);
    const [errorMsg, setErrorMsg] = useState(null);
    const [openLicenseInfo,setOpenLicenseInfo] = useState(false);

    const handleTabChange = (e, newValue) => {
        setErrorMsg(null);
        setTabVal(newValue);
        switch (newValue) {
            case '1':
                setValue('citationNo', null);
                setValue('licensePlateNumber', null);
                setValue('firstName', null);
                setValue('lastName', null);
                break;
            case '2':
                setValue('caseNo', null);
                setValue('licensePlateNumber', null);
                setValue('firstName', null);
                setValue('lastName', null);
                break;
            case '3':
                setValue('caseNo', null);
                setValue('citationNo', null);
                setValue('licensePlateNumber', null);
                break;
            case '4':
                setValue('caseNo', null);
                setValue('citationNo', null);
                setValue('firstName', null);
                setValue('lastName', null);
                break;
        }
    }

    const handleSearch = (form) => {
        const errors = validateSearch(tabVal, form, dob, court);
        if (errors) {
            setErrorMsg(errors);
        } else {
            setErrorMsg(null);
            const query = getSearchRequest(tabVal, form, dob, court);
            retrieveBalances(query);
        }
    }
    const closeLicenseInfo = () => {
        setOpenLicenseInfo(false);
    }


    const clearForm = () => {
        setErrorMsg(null);
        setDob(null);
        setValue('caseNo', null);
        setValue('licensePlateNumber', null);
        setValue('citationNo', null);
        setValue('firstName', null);
        setValue('lastName', null);
    }

    return (<>
        { errorMsg &&
            <Alert severity='error'>
                <AlertTitle>Please correct the following error and try again:</AlertTitle>
                {errorMsg}
            </Alert>
        }
        { openLicenseInfo &&
            <Popup
                open={openLicenseInfo}
                setDone={closeLicenseInfo}
                component={
                    <Typography component='div'>Enter your license plate number with no spaces or dashes (do not enter the state).</Typography>
                }
            />
        }
        <Typography variant='subtitle1' color='primary' sx={{marginTop: '1rem', fontSize: '1.1rem'}}>Look up by:</Typography>
        <Box component='div' sx={{ width: '100%', typography: 'body1', fontSize: '.9rem' }}>
            <TabContext value={tabVal} >
                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                    <Tabs
                        value={tabVal}
                        onChange={handleTabChange}
                        variant='scrollable'
                        scrollButtons='auto'
                    >
                        <Tab label={getCitationLabel(court)} value='2' wrapped={true}/>
                        <Tab label={getCaseLabel(court)} value='1' wrapped={true} />
                        { court.licensePlateLookup &&
                            <Tab label={getLicenseLabel(court)} value='4' wrapped={true}/>
                        }
                        <Tab label='Name' value='3' wrapped={true}/>
                    </Tabs>
                </Box>
                <TabPanel value='1' sx={{padding: '1rem'}}>
                    <Grid2 container spacing={1}>
                        { !court.noDobLookup && court.interfaceUrl &&
                            <Alert severity='warning' icon={false}>{`${court.courtName} requires the DOB for lookups`}</Alert>
                        }
                        <Grid2
                            size={{
                                xs: 12,
                                sm: 6,
                                md: 12,
                                lg: 6
                            }}>
                            <FormControl
                                fullWidth
                                {...register('caseNo')}
                            >
                                <FormLabel shrink={true} sx={classes.inputLabel}>{getCaseLabel(court)} *</FormLabel>
                                <TextField
                                    name='caseNo'
                                    variant='outlined'
                                    fullWidth
                                    slotProps={{
                                        htmlInput: {sx: classes.textbox}
                                    }}
                                />
                            </FormControl>
                        </Grid2>
                        <Dob dob={dob} setDob={setDob} />
                    </Grid2>
                </TabPanel>
                <TabPanel value='2' sx={{padding: '1rem'}}>
                    <Grid2 container spacing={1}>
                        { !court.noDobLookup && court.interfaceUrl &&
                            <Alert severity='warning' icon={false}>{`${court.courtName} requires the DOB for lookups`}</Alert>
                        }
                        <Grid2
                            size={{
                                xs: 12,
                                sm: 6,
                                md: 12,
                                lg: 6
                            }}>
                            <FormControl
                                fullWidth
                                {...register('citationNo')}
                            >
                                <FormLabel shrink={true} sx={classes.inputLabel}>{getCitationLabel(court)} *</FormLabel>
                                <TextField
                                    name='citationNo'
                                    variant='outlined'
                                    fullWidth
                                    slotProps={{
                                        htmlInput: {sx: classes.textbox}
                                    }}
                                />
                            </FormControl>
                        </Grid2>
                        <Dob dob={dob} setDob={setDob} />
                    </Grid2>
                </TabPanel>
                <TabPanel value='3' sx={{padding: '1rem'}}>
                    <Grid2 container spacing={1}>
                        <Grid2
                            size={{
                                xs: 12,
                                sm: 6,
                                md: 12,
                                lg: 6
                            }}>
                            <FormControl
                                fullWidth
                                {...register('firstName')}
                            >
                                <FormLabel shrink={true} sx={classes.inputLabel}>First Name</FormLabel>
                                <TextField
                                    name='firstName'
                                    variant='outlined'
                                    fullWidth
                                    slotProps={{
                                        htmlInput: {sx: classes.textbox}
                                    }}
                                />
                            </FormControl>
                        </Grid2>
                        <Grid2
                            size={{
                                xs: 12,
                                sm: 6,
                                md: 12,
                                lg: 6
                            }}>
                            <FormControl
                                fullWidth
                                required
                                {...register('lastName')}
                            >
                                <FormLabel shrink={true} sx={classes.inputLabel}>Last Name</FormLabel>
                                <TextField
                                    name='lastName'
                                    variant='outlined'
                                    fullWidth
                                    slotProps={{
                                        htmlInput: {sx: classes.textbox}
                                    }}
                                />
                            </FormControl>
                        </Grid2>
                        <Dob dob={dob} setDob={setDob} />
                    </Grid2>
                </TabPanel>
                { court.licensePlateLookup &&
                    <TabPanel value='4' sx={{padding: '1rem'}}>
                        <Grid2 container spacing={1} alignItems='top'>
                            <Grid2
                                size={{
                                    xs: 12,
                                    md: 6
                                }}>
                                <FormControl fullWidth sx={classes.formControl
                                } {...register('licensePlateNumber')}>
                                    <FormLabel shrink={true} sx={classes.inputLabel} htmlFor='licenseLookupNumber'>
                                        {getLicenseLabel(court)}
                                    </FormLabel>
                                    <TextField
                                        id='licensePlateNumber'
                                        variant='outlined'
                                        name="licensePlateNumber"
                                        fullWidth
                                        slotProps={{
                                            input: {
                                                endAdornment: (
                                                    <InputAdornment position='end'>
                                                        <Tooltip title={`License Plate Information`} arrow slots={{
                                                            transition: Zoom
                                                        }}>
                                                            <InfoOutlined color='primary' onClick={() => setOpenLicenseInfo(true)}/>
                                                        </Tooltip>
                                                    </InputAdornment>
                                                )
                                            },

                                            htmlInput: {sx: classes.textbox}
                                        }} />
                                </FormControl>
                            </Grid2>
                        </Grid2>
                    </TabPanel>
                }
            </TabContext>
            < Grid2 sx={{marginLeft: '1rem'}} size={12}>
                <Typography variant='body2' component='Grid2'>* indicates a required field</Typography>
            </Grid2>
        </Box>
        <Box component='div' sx={{...classes.root, display: 'flex', flexDirection: 'row-reverse', marginTop: '1rem'}} >
            <Button
                variant='contained'
                color='primary'
                startIcon={<ManageSearchIcon />}
                sx={classes.squashedButton}
                onClick={handleSubmit(handleSearch)}
            >
                Search
            </Button>
            <Button
                variant='outlined'
                color='primary'
                startIcon={<RotateLeftIcon />}
                sx={classes.squashedButton}
                onClick={() => clearForm()}
            >
                Clear
            </Button>
            { user && user.printUserReceipts &&
                <UserReceipts />
            }
            { logEntry &&
                <Button
                    variant='contained'
                    color='primary'
                    startIcon={<AddIcCallTwoToneIcon />}
                    sx={classes.squashedButton}
                    onClick={() => setNewCall(true)}
                >
                    Log Call
                </Button>
            }
        </Box>
    </>);
}

export default Search;
